import React, { useState, useEffect } from 'react';

const ImageUpload = ({ imageUrl, onImageChange }) => {
    const [preview, setPreview] = useState(imageUrl || null);

    useEffect(() => {
        setPreview(imageUrl);
    }, [imageUrl]);

    const handleImageSelect = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPreview(URL.createObjectURL(file));
            onImageChange(file); // send File to parent
        }
    };

    const handleDelete = () => {
        setPreview(null);
        onImageChange(null); // signal deletion
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block', maxHeight: '250px' }}>
            {preview ? (
                <>
                    <img
                        src={preview}
                        alt="Preview"
                        // style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                        style={{
                            maxHeight: '250px',
                            width: 'auto',
                            height: 'auto',
                            display: 'block',
                            borderRadius: '8px',
                            border: '1px solid #ccc',
                            backgroundColor: '#f9f9f9'
                        }}
                        draggable={false}
                    />
                    <button
                        type="button"
                        onClick={handleDelete}
                        style={{
                            position: 'absolute',
                            top: '5px',
                            right: '5px',
                            backgroundColor: 'red',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '50%',
                            width: '25px',
                            height: '25px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: 0
                        }}
                    >
                        ×
                    </button>
                </>
            ) : (
                <label
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '1px dashed #ccc',
                        width: '180px',
                        height: '180px',
                        cursor: 'pointer',
                        borderRadius: '8px',
                        backgroundColor: '#fafafa',
                        color: '#888'
                    }}
                >
                    <span>Upload Image</span>
                    <input type="file" accept="image/*" style={{ display: 'none' }} onChange={handleImageSelect} />
                </label>
            )}
        </div>
    );
};

export default ImageUpload;
